import { Component, Input, TemplateRef, ViewChild } from '@angular/core';

@Component({
    selector: 'lib-segmented-button-item',
    templateUrl: './segmented-button-item.component.html',
    styleUrl: './segmented-button-item.component.scss'
})
export class SegmentedButtonItemComponent<T> {

    @Input({required: true}) value!: T;
    @Input() disabled: boolean = false;
    @Input() qaTag: string = "";

    @ViewChild('content', {static: true, read: TemplateRef}) label!: TemplateRef<any>;
}
